import React from "react";
import "./CustomNotification.css";
import CloseIcon from "@material-ui/icons/Close";

function CustomNotification({ image, data }) {
  return (
    <div className="customNotification">
      <CloseIcon className="closeIcon" fontSize="small" />
      <div className="customNotification__details">
        <img src={image} alt="product_image" />
        <p>{`${data} successfully added to the baseket.`}</p>
      </div>
    </div>
  );
}

export default CustomNotification;
